import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ifc-props"
}
const _hoisted_2 = { class: "ifc-props__name" }
const _hoisted_3 = { class: "table table-condensed ifc-props__table" }
const _hoisted_4 = { class: "ifc-props__guid" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ifc-props__type" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "ifc-props__section" }
const _hoisted_9 = { class: "table table-condensed ifc-props__table" }
const _hoisted_10 = { class: "ifc-props__key" }
const _hoisted_11 = ["value", "onChange"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ifc-props__section" }
const _hoisted_14 = { class: "table table-condensed ifc-props__table" }
const _hoisted_15 = { class: "ifc-props__key" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "table table-condensed ifc-props__table" }
const _hoisted_18 = { class: "ifc-props__key" }
const _hoisted_19 = {
  key: 1,
  class: "ifc-props__empty"
}

import type { IfcNodeDto } from 'api/IfcParser/Application/Models/IfcNodeDto';
    import type { IfcPropertyDto } from 'api/IfcParser/Application/Models/IfcPropertyDto';
    import type { IfcQuantityDto } from 'api/IfcParser/Application/Models/IfcQuantityDto';
    import type { IfcMaterialDto } from 'api/IfcParser/Application/Models/IfcMaterialDto';

    /**
     * Shared property panel — renders an IfcNodeDto's name / class / GlobalId /
     * import type / property sets / quantity sets / materials. Used by both the
     * IfcImporter (read-only) and the IfcEditor (editable).
     *
     * For editable mode, the parent listens to `propertyChanged` and writes the
     * new value back through whatever backend it owns (web-ifc.WriteLine for the
     * editor, no-op for the importer). The event carries the property reference,
     * its parent set name, and the new value — that's enough for any backend.
     */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IfcPropertiesPanel',
  props: {
    node: {},
    editable: { type: Boolean },
    showHeaderExtras: { type: Boolean }
  },
  emits: ["propertyChanged", "headerAction"],
  setup(__props: any) {

    const props = __props;

    

return (_ctx: any,_cache: any) => {
  return (__props.node)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.node.name || __props.node.ifcClass), 1 /* TEXT */),
        _createCommentVNode(" Header extras (e.g. bSDD info button) — opt-in. "),
        (__props.showHeaderExtras)
          ? _renderSlot(_ctx.$slots, "header-extras", { key: 0 })
          : _createCommentVNode("v-if", true),
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", { class: "ifc-props__key" }, "Class", -1 /* CACHED */)),
              _createElementVNode("td", null, _toDisplayString(__props.node.ifcClass), 1 /* TEXT */)
            ]),
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", { class: "ifc-props__key" }, "GlobalId", -1 /* CACHED */)),
              _createElementVNode("td", _hoisted_4, _toDisplayString(__props.node.globalId), 1 /* TEXT */)
            ]),
            (__props.node.importType)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createElementVNode("td", { class: "ifc-props__key" }, "Import type", -1 /* CACHED */)),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(__props.node.importType), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (__props.node.description)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", { class: "ifc-props__key" }, "Description", -1 /* CACHED */)),
                  _createElementVNode("td", null, _toDisplayString(__props.node.description), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createCommentVNode(" Property Sets "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.propertySets || [], (pset, pi) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `pset-${pi}`
          }, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString(pset.name), 1 /* TEXT */),
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pset.properties || [], (prop, j) => {
                  return (_openBlock(), _createElementBlock("tr", { key: j }, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(prop.name), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      (__props.editable)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            class: "ifc-props__input",
                            value: prop.value,
                            onChange: ($event: any) => (
                                _ctx.$emit('propertyChanged', {
                                    setName: pset.name,
                                    prop,
                                    newValue: ($event.target as HTMLInputElement).value,
                                })
                            )
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(prop.value), 1 /* TEXT */))
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" Quantity Sets "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.quantitySets || [], (qset, qi) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `qset-${qi}`
          }, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(qset.name), 1 /* TEXT */),
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qset.quantities || [], (q, j) => {
                  return (_openBlock(), _createElementBlock("tr", { key: j }, [
                    _createElementVNode("td", _hoisted_15, _toDisplayString(q.name), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(q.value), 1 /* TEXT */),
                      ((q as IfcQuantityDto).unit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString((q as IfcQuantityDto).unit), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" Materials "),
        ((__props.node.materials || []).length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "ifc-props__section" }, "Materials", -1 /* CACHED */)),
              _createElementVNode("table", _hoisted_17, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.materials as IfcMaterialDto[], (mat, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(mat.name), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(mat.thickness ? mat.thickness + ' mm' : ''), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_19, " Select an element to view properties "))
}
}

})